module.exports = __webpack_public_path__ + "img/strategies_thinkPositively.224a62ef.png";